import { Coordinate } from "../buildingTableViewModel";

export class ValidateOutsideSurveyDto {
  surveyId: string;
  surveyStatus: number;
  validatorRemark: string;
  coordinates: Coordinate[];

  constructor(data: {
    surveyId: string;
    surveyStatus: number;
    validatorRemark: string;
    coordinates: Coordinate[];
  }) {
    this.surveyId = data.surveyId;
    this.surveyStatus = data.surveyStatus;
    this.validatorRemark = data.validatorRemark;
    this.coordinates = data.coordinates;
  }
}
export class SaveValidateOutsideSurveyDto {
  surveyId: string;
  surveyStatus: number;
  validatorRemark: string;
  coordinates: Coordinate[];
  constructor(data: {
    surveyId: string;
    surveyStatus: number;
    validatorRemark: string;
    coordinates: Coordinate[];
  }) {
    this.surveyId = data.surveyId;
    this.surveyStatus = data.surveyStatus;
    this.validatorRemark = data.validatorRemark;
    this.coordinates = data.coordinates;
  }
}
export class ValidateInsideSurveyDto {
  surveyId: string;
  validatorRemark?: string;
  deleteTSA: boolean = false;

  constructor(data: {
    surveyId: string;
    validatorRemark: string;
    deleteTSA: boolean;
  }) {
    this.surveyId = data.surveyId;
    this.validatorRemark = data.validatorRemark;
    this.deleteTSA = data.deleteTSA;
  }
}

export class SaveValidateInsideSurveyDto {
  surveyId: string;
  validatorRemark?: string;

  constructor(data: { surveyId: string; validatorRemark: string }) {
    this.surveyId = data.surveyId;
    this.validatorRemark = data.validatorRemark;
  }
}
